import React from "react";
import Markdown from "@irati/ui/src/Markdown";
import { getThumbnailImage } from "@irati/utils/images/getImageSize/getImageSize";
import Close from "@irati/ui/src/Close";
import { CenteredH3, CenteredThumbnailImage, DealDescriptionText } from "./styled";
import DescriptionModal from "../styled/DescriptionModal";
var DealDescriptionModal = function (_a) {
    var deal = _a.deal, onHide = _a.onHide;
    return (React.createElement(DescriptionModal, { dialogClassName: "dealDescriptionPopUp", backdrop: true, backdropClassName: "consistentBackdrop", show: !!deal, onHide: onHide },
        React.createElement(CenteredThumbnailImage, { src: getThumbnailImage(deal.thumbnailImage) }),
        React.createElement(Close, { top: "20px", right: "20px", onClick: onHide }),
        React.createElement(CenteredH3, { className: "push--bottom" }, deal.header),
        React.createElement(DealDescriptionText, null,
            React.createElement(Markdown, { source: deal.description }))));
};
export default DealDescriptionModal;
